import CreateCopyTemplatePopup from './CreateCopyTemplatePopup'
export default CreateCopyTemplatePopup
